import { Component, OnInit } from '@angular/core';
import { Footer } from 'src/app/models';
import { CommonService, GoogleService, ModalService } from 'src/app/services';
import jsonData from '../../data/booths.json';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    public data: Footer = jsonData.footer;
    public lowerOpen: boolean = false;
    public footerEl: HTMLElement;

    constructor(
        private commonSvc: CommonService,
        private modalSvc: ModalService,
        private googleSvc: GoogleService
    ) { }

    ngOnInit(): void {
        this.footerEl = document.getElementById('footer');
        this.commonSvc.setFooterHeight();
    }

    public linkClick(link: any): void {
        this.googleSvc.sendGAEventById(6, { category: link.text, label: link.href });
        window.open(link.href);
    }

    public toggleLower(e): void {
        e.preventDefault();

        this.lowerOpen = !this.lowerOpen;
        this.commonSvc.setFooterExpanded(this.lowerOpen);
        this.commonSvc.setFooterHeight();

        this.googleSvc.sendGAEventById(8, { category: this.lowerOpen ? 'open' : 'close' });

        if (this.modalSvc.modalData.value !== undefined) {
            this.modalSvc.hideModal();
        }
    }
}
